import { useEffect } from "react";

import { Button } from "@/components/ui/button";

/** A small modal for an error the person has to acknowledge. */
export function ErrorDialog({
  title,
  message,
  onClose,
}: {
  title: string;
  message: string;
  onClose: () => void;
}) {
  useEffect(() => {
    function onKey(ev: KeyboardEvent) {
      if (ev.key === "Escape") onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-foreground/40 p-4 sm:p-8"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="error-dialog-title"
      aria-describedby="error-dialog-message"
      onClick={(ev) => {
        if (ev.target === ev.currentTarget) onClose();
      }}
    >
      <div className="w-full max-w-sm space-y-4 rounded-2xl border border-border bg-card p-5 shadow-xl">
        <div>
          <h2 id="error-dialog-title" className="text-lg font-semibold">
            {title}
          </h2>
          <p
            id="error-dialog-message"
            className="mt-1 text-sm text-muted-foreground"
          >
            {message}
          </p>
        </div>
        <div className="flex justify-end">
          <Button autoFocus onClick={onClose}>
            OK
          </Button>
        </div>
      </div>
    </div>
  );
}
